import { ShippingOption, DisplayData } from '../types';

type LocalizedDisplayValues = Omit<DisplayData, 'locale'>;

/* Use localized displayName and description if provided on SPEEDO response */
export const overrideMerchandisingDisplayDataIfNecessary = (
  shippingOption: ShippingOption,
  locale: string
): LocalizedDisplayValues => {
  let localizedDisplayData: DisplayData | undefined;
  if (
    shippingOption.displayText.displayData &&
    shippingOption.displayText.displayData.length > 0
  ) {
    localizedDisplayData = shippingOption.displayText.displayData.find(
      displayData => displayData.locale === locale
    );
    if (localizedDisplayData) {
      return {
        name: localizedDisplayData.name ?? shippingOption.displayText.name,
        description: localizedDisplayData.description,
        displayTextOverrides: localizedDisplayData.displayTextOverrides,
      };
    }
  }

  // name is required
  return {
    name: shippingOption.displayText.name,
  };
};
